const UpsellPrice = {
	rule: function (type, quantity) {

		if (type == "dvd") {
			var originalPrice = Number(
				$("[data-dvd-price]").attr("data-dvd-price")
			);
		} else if (type == "usb") {
			var originalPrice = Number(
				$("[data-usb-price]").attr("data-usb-price")
			);
		} else if (type == "enhanced-content") {
			var originalPrice = Number(
				$("[data-enhanced-content-price]").attr("data-enhanced-content-price")
			);
		}

		if (type == "dvd") {
			$(".product-price").attr(
				"data-upsell-dvd-total-price",
				originalPrice * quantity
			);
		} else if (type == "usb") {
			$(".product-price").attr(
				"data-upsell-usb-total-price",
				originalPrice * quantity
			);
		} else if (type == "enhanced-content") {
			$(".product-price").attr(
				"data-upsell-enhanced-content-total-price",
				originalPrice * quantity
			);
    }

		var totalUsbPrice = $(".product-price").attr(
			"data-upsell-usb-total-price"
		);
		var totalDvdPrice = $(".product-price").attr(
			"data-upsell-dvd-total-price"
		);

    var totalEnhancedContentPrice = $(".product-price").attr(
			"data-upsell-enhanced-content-total-price"
		);

		var newPriceRegular =
			Number($(".product-price").attr("data-total-compare-price")) +
			Number(totalUsbPrice) +
			Number(totalDvdPrice) +
      Number(totalEnhancedContentPrice);
		var newPriceSale =
			Number($(".product-price").attr("data-total-price")) +
			Number(totalUsbPrice) +
			Number(totalDvdPrice) +
      Number(totalEnhancedContentPrice);

		$(".product-price .price-item--regular").text(
			formatMoney(newPriceRegular)
		);

		$(".product-price .price-item--sale").text(formatMoney(newPriceSale));
	},
};

document.addEventListener("DOMContentLoaded", () => {
  const dvdInput = $('input[name=dvd-quantity]');
  const usbInput = $('input[name=usb-quantity]');
  const enhancedContentInput = $('input[name=enhanced-content-quantity]');

	// Handle DVD / USB Input price change
	usbInput.change(function (e) {
		UpsellPrice.rule("usb", $(this).val());
	});
	dvdInput.change(function (e) {
		UpsellPrice.rule("dvd", $(this).val());
	});

  enhancedContentInput.change(function (e) {
    var quantity = 0;
    if ($(this).is(':checked')) {
      quantity = 1;
    }
		UpsellPrice.rule("enhanced-content", quantity);
	});

});